import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_BASE_URL } from 'config/api';

const blogApi = createApi({
  reducerPath: 'blogApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_BASE_URL,
  }),
  endpoints: (builder) => ({
    getPosts: builder.query({
      query: () => 'blog',
    }),
    getPostById: builder.query({
      query: (id) => `blog/${id}`,
    }),
  }),
});

export const { useGetPostsQuery, useGetPostByIdQuery } = blogApi;

export default blogApi;
